export const userUniquinessValidation = (values) => {
    if (!Array.isArray(values.clientDbUserApplications)) return undefined;
    const errors = {};
    const permitsArray = values.clientDbUserApplications;

    for (let i = 0; i < permitsArray.length; i++) {
        for (let j = 0; j < permitsArray.length; j++) {
            if (i !== j) {
                if (
                    permitsArray[i].userId === permitsArray[j].userId &&
                    permitsArray[i].applicationName === permitsArray[j].applicationName
                ) {
                    if (
                        values.clientDbUserApplications &&
                        values.clientDbUserApplications[i] &&
                        values.clientDbUserApplications[i].userId
                    ) {
                        const lastInserted = i > j ? i : j;
                        errors.clientDbUserApplications = [];

                        // Eerror Array is filled with undefined values
                        for (let k = 0; k < lastInserted; k++)
                            errors.clientDbUserApplications.push(undefined);

                        errors.clientDbUserApplications.splice(lastInserted, 0, {
                            userId: 'Toks įrašas jau egzistuoja',
                        });
                    }

                    return errors;
                }
            }
        }
    }
    return undefined;
};

export const appLicencesValidation = (values) => {
    if (!Array.isArray(values.clientDbAppLicense)) return undefined;
    const errors = {};
    const permitsArray = values.clientDbAppLicense;

    for (let i = 0; i < permitsArray.length; i++) {
        for (let j = 0; j < permitsArray.length; j++) {
            if (i !== j) {
                if (permitsArray[i].applicationName === permitsArray[j].applicationName) {
                    if (
                        values.clientDbAppLicense &&
                        values.clientDbAppLicense[i] &&
                        values.clientDbAppLicense[i].applicationName
                    ) {
                        const lastInserted = i > j ? i : j;
                        errors.clientDbAppLicense = [];

                        // Eerror Array is filled with undefined values
                        for (let k = 0; k < lastInserted; k++)
                            errors.clientDbAppLicense.push(undefined);

                        errors.clientDbAppLicense.splice(lastInserted, 0, {
                            applicationName: 'Toks įrašas jau egzistuoja',
                        });
                    }

                    return errors;
                }
            }
        }
    }
    return undefined;
};

export const usersQuantityByLicencesValidation = (values) => {
    if (!Array.isArray(values.clientDbUserApplications)) return undefined;

    const permitsArray = values.clientDbUserApplications;
    const licenseCount = values.clientDbAppLicense || [];

    const errors = {
        clientDbUserApplications: Array(permitsArray.length).fill(undefined),
        clientDbAppLicense: Array(licenseCount.length).fill(undefined),
    };

    let showError = false;

    const usedLicenses = {};
    permitsArray.forEach((row) => {
        usedLicenses[row.applicationName] = (usedLicenses[row.applicationName] || 0) + 1;
    });

    if (licenseCount.length === 0 && Object.keys(usedLicenses).length > 0) {
        showError = true;
        permitsArray.forEach((_, i) => {
            errors.clientDbUserApplications[i] = { userId: 'Nepakanka licencijų' };
        });
        return errors;
    }

    licenseCount.forEach((app, licenseIndex) => {
        const used = usedLicenses[app.applicationName] || 0;
        const exceeded = used > app.licenseCount;

        if (exceeded) {
            showError = true;
            errors.clientDbAppLicense[licenseIndex] = {
                applicationName: 'Viršytas licencijų kiekis',
            };

            permitsArray.forEach((row, i) => {
                if (row.applicationName === app.applicationName) {
                    errors.clientDbUserApplications[i] = {
                        userId: 'Viršytas licencijų kiekis',
                    };
                }
            });
        }
    });
    return showError ? errors : undefined;
};
